// extracted by mini-css-extract-plugin
export default {"topbar":"Layout_topbar__hERco","main-window":"Layout_main-window__C+jZK","bottom-pane":"Layout_bottom-pane__evqm6"};